import { Button, HStack, Modal, ModalBody, ModalContent, ModalOverlay, Text, VStack } from '@chakra-ui/react';
import useModelAvaliacaoLoja from 'components/AvaliacaoLoja/useModelAvaliacaoLoja';
import { useNavigate } from 'react-router-dom';

function AvaliacaoLoja(props) {
  const disclosure = props.disclosure;
  const { agenda_exames_id } = props;
  const { theme, loading, error, registrarCliqueAvaliacao, success, showIOSButton, abrirAppStore, user } = useModelAvaliacaoLoja();
  const navigate = useNavigate();
  return (
    <>
      <Modal isOpen={disclosure.isOpen} isCentered>
        <ModalOverlay />
        <ModalContent m={'8%'} borderRadius="0.8em">
          <ModalBody>
            <VStack spacing={4} mt={4} mb={4}>
              <Text fontSize={'20px'} textAlign={'center'} fontWeight={'bold'}>
                Que tal nos avaliar na loja?
              </Text>
              <Text fontSize={'14px'} textAlign={'center'}>
                Sua opinião é muito importante para nós e ajuda outras pessoas a conhecerem nossos serviços. Leva apenas um minuto!
              </Text>

              {error && (
                <Text fontSize={'14px'} textAlign={'center'} color="red.500">
                  Ocorreu um erro ao registrar sua escolha. Por favor, tente novamente.
                </Text>
              )}

              {!success && !showIOSButton && (
                <>
                  <HStack w={'100%'}>
                    <Button
                      variant="outline"
                      color="black"
                      fontWeight="bold"
                      w={'100%'}
                      onClick={() => registrarCliqueAvaliacao('AVALIAR_DEPOIS', agenda_exames_id, disclosure)}
                      isDisabled={loading}
                    >
                      Avaliar Depois
                    </Button>

                    <Button
                      bg={theme.background}
                      color="white"
                      fontWeight="bold"
                      w={'100%'}
                      onClick={() => registrarCliqueAvaliacao('AVALIAR_AGORA', agenda_exames_id, disclosure)}
                      isDisabled={loading}
                    >
                      Avaliar agora
                    </Button>
                  </HStack>
                </>
              )}

              {showIOSButton && (user.device === 'ios' || user.device === 'iOS') && (
                <Button onClick={abrirAppStore} bg={theme.background} color="white" fontWeight="bold" w={'100%'}>
                  Abrir App Store
                </Button>
              )}

              {success && (
                <>
                  <Text fontSize={'14px'} textAlign={'center'} color="green.500">
                    Obrigado por escolher nos avaliar!
                  </Text>
                  <Button bg={theme.background} color="white" fontWeight="bold" w={'100%'} onClick={() => navigate('/dashboard')}>
                    Ir para o dashboard
                  </Button>
                </>
              )}
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AvaliacaoLoja;
